import React from 'react'

// material ui
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'

// components
import LocationOption from './LocationOption'

// utils
import { sortBy } from 'lib/helpers/lists'

// return a list of unique regions for the given locations
const regionsForLocations = locations =>
  [...new Set(locations.map(location => location.regionTitle))].sort()

// return a sorted list of locations for the given region
const locationsForRegion = (region, locations) =>
  locations
    .filter(location => location.regionTitle === region)
    .sort(sortBy('name'))

const LocationMenu = props => {
  const { locations, cartProduct, onChangeLocation, isMobile } = props
  const regions = regionsForLocations(locations)
  const { location } = cartProduct || {}

  const selectedValue = location ? location.id : ''

  return (
    <Select
      variant='outlined'
      name='change-location'
      value={selectedValue}
      onChange={onChangeLocation}
      displayEmpty
    >
      <MenuItem value=''>Locations…</MenuItem>
      {regions.map(region => [
        <ListSubheader key='subheader' disableSticky>
          {region}
        </ListSubheader>,
        locationsForRegion(region, locations).map(location => (
          <MenuItem key={location.id} value={location.id}>
            <LocationOption location={location} isMobile={isMobile} />
          </MenuItem>
        ))
      ])}
    </Select>
  )
}

export default LocationMenu
